import "@/App.css";
import { lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { LanguageProvider } from "@/i18n/LanguageContext";
import { SettingsProvider } from "@/lib/useSettings";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import News from "@/pages/News";
import Jobs from "@/pages/Jobs";
import Alerts from "@/pages/Alerts";
import Insights from "@/pages/Insights";
import InsightDetail from "@/pages/InsightDetail";
import About from "@/pages/About";
// Admin bundle is lazy-loaded so the WYSIWYG editor + LLM assistant code
// never ships with the public bundle (saves ~80-120 KB and removes a major
// source of unused JS on Home — flagged by PageSpeed Mobile).
const Admin = lazy(() => import("@/pages/Admin"));
import Search from "@/pages/Search";
import { NewsDetail, JobDetail, AlertDetail } from "@/pages/Details";
import { Tutorials, TutorialDetail } from "@/pages/Tutorials";
import SubmitNews from "@/pages/SubmitNews";
import Contact from "@/pages/Contact";
import Topic from "@/pages/Topic";
import Tech from "@/pages/Tech";
import { EcosystemHub, EcosystemList, EcosystemDetail } from "@/pages/Ecosystem";
import Analytics from "@/components/Analytics";

const AdminFallback = () => (
  <div className="dl-container py-20 text-[#4B5563] text-sm">Loading admin…</div>
);

function App() {
  return (
    <HelmetProvider>
      <LanguageProvider>
        <SettingsProvider>
          <BrowserRouter>
          <Analytics />
          <div className="App min-h-screen flex flex-col">
            <Header />
            <main className="flex-1">
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/news" element={<News />} />
                <Route path="/news/:id" element={<NewsDetail />} />
                <Route path="/jobs" element={<Jobs />} />
                <Route path="/jobs/:id" element={<JobDetail />} />
                <Route path="/alerts" element={<Alerts />} />
                <Route path="/alerts/:id" element={<AlertDetail />} />
                <Route path="/insights" element={<Insights />} />
                <Route path="/insights/:id" element={<InsightDetail />} />
                <Route path="/tutorials" element={<Tutorials />} />
                <Route path="/tutorials/:id" element={<TutorialDetail />} />
                <Route path="/about" element={<About />} />
                <Route
                  path="/admin"
                  element={(
                    <Suspense fallback={<AdminFallback />}>
                      <Admin />
                    </Suspense>
                  )}
                />
                <Route path="/search" element={<Search />} />
                <Route path="/submit" element={<SubmitNews />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/topic/:slug" element={<Topic />} />
                <Route path="/tech/:slug" element={<Tech />} />
                <Route path="/ecosystem" element={<EcosystemHub />} />
                <Route path="/ecosystem/:kindPath" element={<EcosystemList />} />
                <Route path="/ecosystem/:kindPath/:slug" element={<EcosystemDetail />} />
              </Routes>
            </main>
            <Footer />
          </div>
        </BrowserRouter>
        </SettingsProvider>
      </LanguageProvider>
    </HelmetProvider>
  );
}

export default App;
